import type { Component } from "solid-js";
import { registerPanel } from "@/panel-registry";
import { NetworkView } from "./network";

const NetworkWifiPanel: Component = () => <NetworkView title="WiFi" view="wifi" />;

registerPanel("network-wifi", NetworkWifiPanel);
export default NetworkWifiPanel;
